(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventScheduleDetailController', EventScheduleDetailController);

    EventScheduleDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'EventSchedule', 'Employee'];

    function EventScheduleDetailController($scope, $rootScope, $stateParams, entity, EventSchedule, Employee) {
        var vm = this;
        vm.eventSchedule = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:eventScheduleUpdate', function(event, result) {
            vm.eventSchedule = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
